import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setAskFirstNameDontShowAt } from "../redux/modules/askFirstNamePrompt";
import { actions as authActions } from "../redux/modules/auth/login";
import { getUserEditValidationErrors } from "../redux/modules/auth/login/selector";

export default function useAskFirstNameModal({ userData, translate }) {
  const dispatch = useDispatch();
  const [firstName, setFirstName] = useState(userData?.first_name || "");
  const [validationError, setValidationError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const apiValidationErrors = useSelector(getUserEditValidationErrors);

  useEffect(() => {
    if (
      submitting &&
      apiValidationErrors &&
      Object.keys(apiValidationErrors).length > 0
    ) {
      setSubmitting(false);
    }
  }, [apiValidationErrors, submitting]);

  const onChangeFirstName = value => {
    setFirstName(value);
    if (validationError) {
      setValidationError(null);
    }
  };

  const handleDontShow = onClose => {
    if (submitting) {
      return;
    }
    dispatch(setAskFirstNameDontShowAt());
    onClose?.();
  };

  const handleSave = onClose => {
    if (submitting) {
      return;
    }

    const trimmed = firstName.trim();

    if (!trimmed) {
      setValidationError(translate("ask_first_name_modal_validation_required"));
      return;
    }

    setValidationError(null);
    setSubmitting(true);

    dispatch(
      authActions.editUserData([{ name: "first_name", value: trimmed }], () => {
        setSubmitting(false);
        onClose?.();
      })
    );
  };

  return {
    firstName,
    validationError,
    submitting,
    onChangeFirstName,
    handleSave,
    handleDontShow
  };
}
